import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {HTMLTag} from '../HTMLTag/HTMLTag';
import s from './OrderSummary.scss';
import cx from 'clsx';
import {CartSummarySkeleton} from './CartSummarySkeleton/CartSummarySkeleton';
import {OrderSummary} from './OrderSummary';

export enum OrderSummaryLayoutDataHook {
  OrderSummaryLayoutHeadline = 'OrderSummary.headline',
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const OrderSummaryLayout = ({shouldShowSkeleton}: {shouldShowSkeleton: boolean}) => {
  const {t} = useTranslation();
  const {orderStore} = useControllerProps();
  const {shouldDisplaySubtotalTitle} = orderStore || {};
  const classNames = cx(s.headline, {
    [s.withSubtotalTitle]: shouldDisplaySubtotalTitle,
  });

  return (
    <div className={s.totals}>
      <HTMLTag type="h2" className={classNames} data-hook={OrderSummaryLayoutDataHook.OrderSummaryLayoutHeadline}>
        {t('cart.orderSummary.title')}
      </HTMLTag>
      {shouldShowSkeleton ? <CartSummarySkeleton /> : <OrderSummary />}
    </div>
  );
};
